import { EliteLandingPageState } from '../../../types/misc.types'
import { familyEliteLandingPageStateConfig } from './familyEliteLandingPageStateConfig'
import { convertEpochToDate } from '../../../utils/utils'
import { ESignLearnMoreContent } from '../../../components/BottomSheetComponents/ESignLearnMoreContent'

interface SupportTextProps {
  eliteLandingPageState: `${EliteLandingPageState}`
  activationExpiryDate?: number
  onOpenBottomSheet: (content: React.ReactNode) => void
  onCloseBottomSheet: () => void
}

export const SupportText = ({
  eliteLandingPageState,
  activationExpiryDate,
  onOpenBottomSheet,
  onCloseBottomSheet
}: SupportTextProps) => {
  const supportText = familyEliteLandingPageStateConfig[eliteLandingPageState]?.supportText

  if (!supportText) {
    return null
  }

  const isWarningState = eliteLandingPageState === EliteLandingPageState.PAYMENT_COMPLETED_SUBSCRIPTION_PENDING_WARNING

  return (
    <div className='flex flex-col items-center justify-center gap-2 px-10 w-full'>
      {isWarningState ? (
        <div className='text-[#CC5C2D] text-center text-[13px] font-[500] py-2'>
          {supportText.replace('{activationExpiryDate}', convertEpochToDate(activationExpiryDate ?? 0, '%d %b'))}
          <span
            onClick={() =>
              onOpenBottomSheet(
                <ESignLearnMoreContent onDismiss={onCloseBottomSheet} activationExpiryDate={activationExpiryDate} />
              )
            }
            className='text-[#CC5C2D] text-[13px] font-[500] hover:opacity-80 transition-opacity underline cursor-pointer ml-1'
          >
            Learn More
          </span>
        </div>
      ) : (
        <div className='text-[#CC5C2D] text-center text-[13px] font-[500] py-2'>{supportText}</div>
      )}
    </div>
  )
}
